import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "sidebar-menu-group" };
import { ref } from 'vue';
import SidebarMenuItem from './sidebar-menu-item.vue';
import SidebarMenuSectionItem from './sidebar-menu-section-item.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'sidebar-menu-section',
    props: {
        label: {},
        url: {},
        iconName: {},
        analytics: {},
        isSelected: { type: Boolean },
        isExpanded: { type: Boolean },
        items: {}
    },
    emits: ['update:toggled'],
    setup(__props) {
        const menuItem = __props;
        const isOpen = ref(menuItem.isExpanded);
        const vMaxHeight = {
            mounted: (el, binding) => {
                if (binding.value?.disabled) {
                    el.style.maxHeight = el.scrollHeight + 'px';
                }
                else {
                    el.style.display = 'block';
                    el.style.maxHeight = el.scrollHeight + 'px';
                    el.style.display = 'none';
                }
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                _createElementVNode("li", null, [
                    (_ctx.items)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(SidebarMenuItem, {
                                "is-expanded": isOpen.value,
                                "menu-item": menuItem,
                                onClick: _cache[0] || (_cache[0] = ($event) => { isOpen.value = !isOpen.value; _ctx.$emit('update:toggled', isOpen.value); })
                            }, null, 8, ["is-expanded", "menu-item"]),
                            _createVNode(_Transition, { name: "menu-open" }, {
                                default: _withCtx(() => [
                                    _withDirectives((_openBlock(), _createElementBlock("ul", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: item.label
                                            }, [
                                                _createVNode(SidebarMenuSectionItem, _mergeProps({ ref_for: true }, item), null, 16)
                                            ]));
                                        }), 128))
                                    ])), [
                                        [_vShow, isOpen.value],
                                        [vMaxHeight, { disabled: isOpen.value }]
                                    ])
                                ]),
                                _: 1
                            })
                        ], 64))
                        : (_openBlock(), _createBlock(SidebarMenuItem, {
                            key: 1,
                            "menu-item": menuItem
                        }, null, 8, ["menu-item"]))
                ])
            ]));
        };
    }
});
